import Intro from "./scenes/intro/Intro.js";
import PickCakeColor from "./scenes/MakeACake/PickCakeColor.js";
import PlaceItems from "./scenes/MakeACake/PlaceItems.js";
import PausePopUp from "./scenes/PopUps/PausePopUp.js"
import RestartPopUp from "./scenes/PopUps/RestartPopUp.js"

export default {
    
    scenes: [
        //Here you can add new scenes on the fly
         Intro,
         PickCakeColor,
         PlaceItems,
         PausePopUp,
         RestartPopUp
    ],
    startScene: Intro.KEY,

    spines: [], //Place the name of the spine file here, excluding the extension
    isDev: false,
    //CakeColor: 0xffffff,
    CakeColor: 0xfaf9eb,

}
